// Libraries
var React = require('react');
var $ = require('jquery');
var PubSub = require('pubsub-js');

// Styles
require('./Timeline.scss');

// Components
var Progress = require('./Progress');
var KeyMoments = require('./KeyMoments');

class TimelineModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showSelf: false,
			showExtraTime: false,
			isShootOut: false,
			minute: null,
			awayCrestUrl: "",
			homeCrestUrl: "",
			selectEvent: true,
			eventsList: [],
		};

		// NEW
		this.highlightsEndpoint = this.props.data.endpoints.find(x => x.name === "highlights");
		this.detailsEndpoint = this.props.data.endpoints.find(x => x.name === "matchDetails");

		this.Realtime = null;

		PubSub.subscribe('StartMdc', this.startMdc);
	}

	// NEW
	ifIsSomething = (cb, x) => {
		if (x)
			return cb(x);
		else
			return x;
	};

	// NEW
	startMdc = () => {
		this.setState({
			showSelf: true
		});
	}

	// NEW
	timestampSort = (a, b) => new Date(a.TimestampIsoFormat) - new Date(b.TimestampIsoFormat);

	// NEW
	isPenaltyType = event => event.Type === 'PenaltyShot';

	// NEW
	isNotPenaltyType = event => event.Type !== 'PenaltyShot';

	// NEW
	offsetPenalties = (event, i) => Object.assign({}, event, { Minute: event.Minutes + i * 2.5 });

	// NEW
	parseEvents = events => [...events]
		.filter(this.isPenaltyType)
		.sort(this.timestampSort)
		.map(this.offsetPenalties)
		.concat(events.filter(this.isNotPenaltyType))
		.sort(this.timestampSort)

	// NEW
	handleHighlights = data => {
		const isDeleted = event => data.Deleted.indexOf(event.Id) === -1;

		const isDuplicate = event =>
			data[data.Items ? 'Items' : 'Updated']
				.findIndex(item => item.Id === event.Id) === -1;

		if(data.HomeCrestUrl && data.AwayCrestUrl) {
			this.setState({
				homeCrestUrl: this.props.data.baseUrl + data.HomeCrestUrl,
				awayCrestUrl: this.props.data.baseUrl + data.AwayCrestUrl
			});
		}

		this.setState({
			eventsList: this.parseEvents([
				...data[data.Items ? 'Items' : 'Updated'],
				...this.state.eventsList.filter(isDeleted).filter(isDuplicate)
			])
		}, this.loadMatchDetails);
	};

	loadMatchDetails = () => {
		$.ajax({
			method: "GET", 
			url: this.detailsEndpoint.url,
		})
			.done(data => {
				this.populateMatchDetails(data);
			});
	};

	loadHighlights = () => {
		$.ajax({
			method: "GET", 
			url: this.highlightsEndpoint.url
		})
			.done(data => {
				this.handleHighlights(data);
			});
	}

	// NEW
	isShootOut = data => data.Period === 'ShootOut' || this.state.eventsList.some(event => event.Period === 'ShootOut');

	// NEW
	isFullTime = data => data.Period === 'FullTime';

	// NEW
	isExtraTime = data => ((this.isFullTime(data) || this.isShootOut(data)) && data.Minutes >= 120) || (data.ShowExtraTime && /Extra(First|Second)Half/.test(data.Period));

	// DISCARD
	populateMatchDetails = data => {
		if (data.Period !== 'None') {
			this.setState({
				minute: data.Minutes,
				showExtraTime: this.isExtraTime(data),
				isFullTime: this.isFullTime(data),
				isShootOut: this.isShootOut(data),
				homeTeamShortName: data.Home.ShortName,
				awayTeamShortName: data.Away.ShortName,
				homeTeamName: data.Home.Name,
				awayTeamName: data.Away.Name
			});
		}
	}

	attachChannels() {
		this.Realtime.subscribe(this.detailsEndpoint.channelId, this.props.data.realtimeKey, message => {
			this.ifIsSomething(this.populateMatchDetails, message.data);
		});

		this.Realtime.subscribe(this.highlightsEndpoint.channelId, this.props.data.realtimeKey, message => {
			this.ifIsSomething(this.handleHighlights, message.data);
		});
	}

	// DISCARD
	selectedEventChangedHandler = (newEventId) => {
		this.setState({ selectedEventId: newEventId, selectEvent: true });
	}

	// DISCARD
	unselectEventsHandler = () => {
		this.setState({ selectEvent: false });
	}

	// NEW
	splitQueryPair = pair => pair.split('=');

	// NEW
	getQueryValue = pair => decodeURIComponent(this.splitQueryPair(pair)[1]);

	// NEW
	getQueryVariable = variable => {
		return this.ifIsSomething(this.getQueryValue,
			window.location.search
				.slice(1)
				.split('&')
				.filter(vars => vars.split('=')[0] === variable)[0]
		);
	}

	skipTimelineHandler = () => {
		document.querySelector('.KeyMoments .slick-active .Slide').focus();
	};

	// NEW
	selectEventById = id => {
		this.setState({
			selectedEventId: id,
		});
	}

	componentDidMount() {
		this.ifIsSomething(this.selectEventById, this.getQueryVariable('keymoment'));

		// delay the load of the realtime library until it's reached the browser
		// to avoid server side rendering errors
		this.Realtime = require('Realtime/Realtime');

		this.loadMatchDetails();
		this.loadHighlights();
		this.attachChannels();
	}

	componentDidUpdate() {
		if(this.vibrate && window.navigator.vibrate) {
			window.navigator.vibrate([200, 30, 200, 30, 200]);
			this.vibrate = false;
		}
	}

	render() {
		return (
			<div className="Timeline">
				{this.state.showSelf &&
						<div className="Timeline__wrapper">
							<button className="Timeline__skip" onClick={this.skipTimelineHandler} type="button">Skip timeline</button>
							<div className="Timeline__teams">
								<div className="Timeline__background"></div>
								<div className="Timeline__detail">
									{this.state.homeTeamShortName &&
											<p><abbr title={this.state.homeTeamName}>{this.state.homeTeamShortName}</abbr></p>
									}
									<div className="Timeline__separator"></div>
									{this.state.awayTeamShortName &&
											<p><abbr title={this.state.awayTeamName}>{this.state.awayTeamShortName}</abbr></p>
									}
								</div>
							</div>
							<Progress 
								selectEvent={this.state.selectEvent} 
								selectedEventId={this.state.selectedEventId} 
								selectedEventChanged={this.selectedEventChangedHandler} 
								events={this.state.eventsList} 
								showExtraTime={this.state.showExtraTime} 
								isShootOut={this.state.isShootOut} 
								isFullTime={this.state.isFullTime}
								minute={this.state.minute} 
							/>         
							<KeyMoments 
								selectedEventId={this.state.selectedEventId} 
								unselectEvents={this.unselectEventsHandler} 
								selectedEventChanged={this.selectedEventChangedHandler} 
								events={this.state.eventsList} 
								awayCrestUrl={this.state.awayCrestUrl} 
								homeCrestUrl={this.state.homeCrestUrl} 
							/>
						</div>
				}
			</div>
		)
	}
}

module.exports = TimelineModule;



// WEBPACK FOOTER //
// ./src/components/MDC/Timeline/TimelineModule.js